module.exports = __webpack_public_path__ + "img/download.e5da8ec1.svg";